import { Injectable } from '@angular/core';
import * as CryptoJS from 'crypto-js';
import * as LZString from 'lz-string';

@Injectable({
    providedIn: 'root'
})
export class LocalStorageService {
    private secretKey = 'Zh59w/!Z53Yy';

    setItem(key: string, value: any): void {
        try {
            const jsonData = JSON.stringify(value);
            const compressedData = LZString.compressToUTF16(jsonData);
            const encryptedData = CryptoJS.AES.encrypt(compressedData, this.secretKey).toString();
            localStorage.setItem(key, encryptedData);
        } catch (error) {
            console.error('Error almacenando en localStorage:', error);
        }
    }

    getItem(key: string): any {
        const storedData = localStorage.getItem(key);
        if (!storedData) return null;

        try {
            const decryptedData = CryptoJS.AES.decrypt(storedData, this.secretKey).toString(CryptoJS.enc.Utf8);
            const decompressedData = LZString.decompressFromUTF16(decryptedData);
            return JSON.parse(decompressedData);
        } catch (error) {
            console.error('Error desencriptando:', error);
            return null;
        }
    }

    removeItem(key: string): void {
        localStorage.removeItem(key);
    }

    clear(): void {
        localStorage.clear();
    }

    setItemWithExpiry(key: string, value: any, minutes: number): void {
        const now = new Date().getTime();
        const item = { value, expiry: now + minutes * 60000 };
        this.setItem(key, item);
    }

    getItemWithExpiry(key: string): any {
        const item = this.getItem(key);
        if (!item) return null;

        const now = new Date().getTime();
        if (now > item.expiry) {
            this.removeItem(key);
            return null;
        }
        return item.value;
    }
}

export class SessionStorageService {
    private secretKey = 'QHwE~C;8bi87';

    setItem(key: string, value: any): void {
        try {
            const jsonData = JSON.stringify(value);
            const compressedData = LZString.compressToUTF16(jsonData);
            const encryptedData = CryptoJS.AES.encrypt(compressedData, this.secretKey).toString();
            sessionStorage.setItem(key, encryptedData);
        } catch (error) {
            console.error('Error almacenando en sessionStorage:', error);
        }
    }

    getItem(key: string): any {
        const storedData = sessionStorage.getItem(key);
        if (!storedData) return null;

        try {
            const decryptedData = CryptoJS.AES.decrypt(storedData, this.secretKey).toString(CryptoJS.enc.Utf8);
            const decompressedData = LZString.decompressFromUTF16(decryptedData);
            return JSON.parse(decompressedData);
        } catch (error) {
            console.error('Error desencriptando:', error);
            return null;
        }
    }

    removeItem(key: string): void {
        sessionStorage.removeItem(key);
    }

    clear(): void {
        sessionStorage.clear();
    }

    setItemWithExpiry(key: string, value: any, minutes: number): void {
        const now = new Date().getTime();
        const item = { value, expiry: now + minutes * 60000 };
        this.setItem(key, item);
    }

    getItemWithExpiry(key: string): any {
        const item = this.getItem(key);
        if (!item) return null;

        const now = new Date().getTime();
        if (now > item.expiry) {
            this.removeItem(key);
            return null;
        }
        return item.value;
    }
}